import React, { useMemo, useState } from 'react';
import { StepComponentProps } from '../wizard.model';
import { ServiceDto } from '../../../../dtos/customer.dto';
import SelectedIcon from '@svg/v-icon-blue.svg?react';
import SearchIcon from '@svg/search.svg?react';
import { Input } from 'antd';
import './connection-step.scss';
import { ConnectionType } from '../../../shared/connection-type/connection-type';
import { ConnectionLevel } from '../../../shared/connection-level/connection-level';
import { keyboardClickable } from '../../../../utils/a11y-utils';

const ConnectionStep: React.FC<StepComponentProps> = ({ data, onDataChange, extraProps }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const headers = ['Connection', 'Type', 'Plan'];

    const handleConnectionChange = (connection: ServiceDto) => {
        onDataChange({ connection });
    };

    const filteredConnections = useMemo(() => {
        return extraProps.connections.filter((connection: ServiceDto) => {
            const connectionName = connection.serviceName || connection.adiCircuitId;
            return connectionName.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [searchTerm, extraProps.connections]);

    return (
        <div className="step">
            <div className="step-header">Let's set up your first connection</div>
            <div className="step-desc">Select one of the connections below to begin setting up your first security policy.</div>
            <div className="step-content">
                <div className="connection-step-table-wrapper">
                    <div className="connection-step-search-wrapper">
                        <Input placeholder="Search"
                               className="connection-step-search"
                               value={searchTerm}
                               prefix={<SearchIcon/>}
                               onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="connection-step-table-header">
                        {headers.map((header, index) => (
                            <div key={index} className="header-cell">
                                {header}
                            </div>
                        ))}
                    </div>
                    <div className="connection-step-table">
                        {filteredConnections.map((connection: ServiceDto) => (
                            <div key={connection.serviceId}
                                 className={`connection-row ${data.connection?.serviceId === connection.serviceId ? 'active' : ''}`}
                                 {...keyboardClickable(() => handleConnectionChange(connection))}>
                                <div
                                    className="connection-selected">{data.connection?.serviceId === connection.serviceId &&
                                    <SelectedIcon/>}
                                </div>
                                <div className="connection-name">{connection.serviceName || connection.adiCircuitId}</div>
                                <ConnectionType circuitType={connection.circuitType} />
                                <ConnectionLevel serviceLevel={connection.serviceLevel} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConnectionStep;